import { useState, useEffect } from 'react';
import { popupManager } from './PopupManager';

class NetworkManager {
  constructor() {
    this.lastNetworkCheck = null;
    this.lastNetworkError = null;
    this.errorCooldown = 5000; // 5 seconds cooldown
  }

  chainParamToChainId(chainParam) {
    switch (chainParam) {
      case "ethereum":
        return 1;
      default:
        return null;
    }
  }

  async validateNetwork(signer, chain) {
    if (!signer) return { isValid: false, error: "No signer" };

    const requiredChainId = this.chainParamToChainId(chain);
    if (!requiredChainId) return { isValid: false, error: "Invalid chain" };

    try {
      const network = await signer.provider.getNetwork();
      const currentChainId = Number(network.chainId);
      
      if (currentChainId !== requiredChainId) {
        // Check if we should show the error (cooldown)
        const now = Date.now();
        const shouldShowError = !this.lastNetworkError || 
          (now - this.lastNetworkError) > this.errorCooldown;

        if (shouldShowError) {
          this.lastNetworkError = now;
          popupManager.addPopup({
            id: Date.now(),
            type: "error",
            message: "Please connect your wallet to the selected network!",
            duration: 6000,
          });
        }

        return { isValid: false, error: "Wrong network" };
      }

      return { isValid: true, error: null };
    } catch (err) {
      console.error("Error checking network:", err);
      return { isValid: false, error: "Network check failed" };
    }
  }

  // Reset cooldown when user changes network
  resetCooldown() {
    this.lastNetworkError = null;
  }
}

// Create singleton instance
export const networkManager = new NetworkManager();

// Hook for components to use
export function useNetworkValidation(signer, chain) {
  const [isValid, setIsValid] = useState(true);

  useEffect(() => {
    if (!signer || !chain) return;

    const checkNetwork = async () => {
      const result = await networkManager.validateNetwork(signer, chain);
      setIsValid(result.isValid);
    };

    checkNetwork();
  }, [signer, chain]);

  return isValid;
} 